"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(bytes) {
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var decimals = 2;
  var labels = ['б', 'кБ', 'мБ', 'гБ'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)), " ").concat(labels[i]);
};